import { render, staticRenderFns } from "./UnifiedParticipants.vue?vue&type=template&id=1a57142b&scoped=true"
import script from "./UnifiedParticipants.vue?vue&type=script&lang=js"
export * from "./UnifiedParticipants.vue?vue&type=script&lang=js"
import style0 from "./UnifiedParticipants.vue?vue&type=style&index=0&id=1a57142b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../2026-08-26/github-cli-gh-codex/work/jiangkv3/web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a57142b",
  null
  
)

export default component.exports